var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-link',{staticClass:"expo-btn expo-btn-white",attrs:{"href":"#","title":_vm.$t('general.filter_reset')},on:{"click":_vm.resetFilters}},[_c('b-icon-bootstrap-reboot'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }